import React from 'react';
import { Container, Box } from '@mui/material';

export const SimpleLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Container>
            <Box sx={{ my: 4 }}>
                {children}
            </Box>
        </Container>
    );
};